import api from './api';

export const claudeService = {
  async sendMessage(message, context, portfolioData = null) {
    try {
      const response = await api.post('/ai/chat?provider=claude', {
        message,
        context,
        portfolioData: portfolioData || null
      });

      if (!response || !response.content) {
        throw new Error('Empty response from AI service');
      }

      return response.content;
    } catch (error) {
      console.error('Claude API error:', error);
      throw error;
    }
  }
};